import { translate as t } from '../lib/I18n';

export function diffDuration (start, end) {
    const diff = end.calendarDiff(start);
    return { hours: (diff.days * 24) + diff.hours, minutes: diff.minutes };
}

export function diffDurationMinutes (start, end) {
    const diff = end.calendarDiff(start);
    return (diff.hours * 60) + diff.minutes;
}

/**
 * Format a duration as a string
 *
 * @param {Object} duration
 * @param {Number} duration.hours
 * @param {Number} duration.minutes
 * @param [Object] options options
 * @param ["short"|"medium"|"long"] options.type
 */
export function durationString (duration, {type = 'short'} = {}) {
    let string = duration.hours > 0 ? t(`time.hours.${type}`, duration) + ' ' : '';
    string += t(`time.minutes.${type}`, duration);
    return string;
}



// WEBPACK FOOTER //
// ./src/helpers/Durations.js